var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 80,
    viewBox: "0 0 216 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.85 80H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 64 0 60.418 0 56s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h51.737c-5 0-9.054-3.582-9.054-8s4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8Zm40.096-32c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 35.582 216 40s-4.054 8-9.054 8Zm-69.634 19.627a237.917 237.917 0 0 0 4.848-1.693v1.32-55.087.088c-10.995 6.393-21.911 9.589-32.748 9.589-10.837 0-20.361-3.196-28.572-9.59v55-1.32c1.666.601 3.282 1.166 4.848 1.693H81c10.167 5.334 20.333 8 30.5 8 10.167 0 20.333-2.666 30.5-8h-4.688ZM111.5 22.08c16.933 0 30.66-4.355 30.66-9.726 0-5.372-13.727-9.727-30.66-9.727s-30.66 4.355-30.66 9.727c0 5.371 13.727 9.726 30.66 9.726Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 1.627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.84 9.627c8.21 6.393 17.735 9.59 28.572 9.59s21.753-3.197 32.748-9.59v53.68c-13.52 4.88-23.74 7.32-30.66 7.32-6.92 0-17.14-2.44-30.66-7.32V9.627Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#6A6666",
    strokeWidth: 2.5,
    cx: 31.5,
    cy: 9.726,
    rx: 30.66,
    ry: 9.726
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.84 9.726v54.901M62.16 9.54v55.087M.84 28.627c10.22 6.004 20.44 9.006 30.66 9.006 10.22 0 20.44-3.002 30.66-9.006M.84 46.627c10.22 6.004 20.44 9.006 30.66 9.006 10.22 0 20.44-3.002 30.66-9.006",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81 66.627c10.167 5.334 20.333 8 30.5 8 10.167 0 20.333-2.666 30.5-8",
    stroke: "#6A6666",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#6A6666",
    transform: "translate(80 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.3,
    y: 26
  }, ".")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#6A6666",
    transform: "translate(80 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.3,
    y: 42
  }, ".")), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#6A6666",
    transform: "translate(80 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.3,
    y: 60
  }, ".")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabases);
export default __webpack_public_path__ + "static/media/databases.d287d123031d732a61f137fc4775e1b2.svg";
export { ForwardRef as ReactComponent };